(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const swipeDistance = 12;
  const cueKey = () => `ps-mobile-card-gallery-peek-v1:${location.pathname}`;
  let cueClaimed = false;
  let lastScrollAt = 0;
  let observer;

  function variants(card) {
    try { return JSON.parse(card.querySelector('[data-product-variants-json]')?.textContent || '[]'); }
    catch (_) { return []; }
  }

  function selectedIds(card) {
    const selected = card.querySelector('.js-product-card-options input[type="radio"][name$="option[1]"]:checked');
    const all = variants(card);
    return (selected ? all.filter(v => v.option1 === selected.value) : all).map(v => String(v.id));
  }

  function renderSelected(media) {
    const card = media.closest('product-card');
    const source = media.querySelector(':scope > template[data-mobile-card-gallery-source]');
    const track = media.querySelector('.mobile-card-gallery__track');
    if (!card || !source || !track) return;
    const ids = selectedIds(card);
    const key = ids.join(',');
    if (track.dataset.galleryKey === key) return;
    track.replaceChildren();
    [...source.content.querySelectorAll('img')]
      .filter(image => (image.dataset.productImages || '').split(',').some(id => ids.includes(id)))
      .forEach(image => { const slide = image.cloneNode(true); slide.classList.remove('hidden'); track.append(slide); });
    track.dataset.galleryKey = key;
    const swipe = track.children.length > 1;
    media.classList.toggle('mobile-card-gallery--swipe-enabled', swipe);
    media.scrollTo({ left: 0, behavior: 'instant' });
  }

  function initialise(media) {
    if (!mobileQuery.matches || media.dataset.mobileGalleryReady) return;
    const source = media.querySelector(':scope > template[data-mobile-card-gallery-source]');
    if (!source || source.content.querySelectorAll('img').length < 2) return;
    media.querySelectorAll(':scope > img:not(.hover-img)').forEach(image => image.remove());
    const track = document.createElement('div');
    track.className = 'mobile-card-gallery__track';
    media.prepend(track);
    media.classList.add('mobile-card-gallery--ready');
    media.dataset.mobileGalleryReady = 'true';
    renderSelected(media);
    queuePeek(media);
    let x = 0, y = 0, swiping = false, cancelClick = false;
    media.addEventListener('pointerdown', e => { if (!media.classList.contains('mobile-card-gallery--swipe-enabled')) return; x=e.clientX; y=e.clientY; swiping=false; }, {passive:true});
    media.addEventListener('pointermove', e => { if (Math.abs(e.clientX-x)>swipeDistance && Math.abs(e.clientX-x)>Math.abs(e.clientY-y)) swiping=true; }, {passive:true});
    media.addEventListener('pointerup', () => { if (swiping) { cancelClick=true; setTimeout(()=>cancelClick=false,350); } }, {passive:true});
    media.addEventListener('click', e => { if (cancelClick) { e.preventDefault(); e.stopPropagation(); } }, true);
    media.closest('product-card')?.addEventListener('change', e => { if (e.target.matches('.js-product-card-options input[type="radio"]')) setTimeout(()=>renderSelected(media)); });
  }

  function queuePeek(media) {
    if (cueClaimed || !location.pathname.startsWith('/collections/') ||
      sessionStorage.getItem(cueKey()) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!media.classList.contains('mobile-card-gallery--swipe-enabled')) return;
    cueClaimed = true;
    const play = (attempt = 0) => {
      if (Date.now() - lastScrollAt < 300 && attempt < 4) return setTimeout(() => play(attempt + 1), 350);
      const track = media.querySelector('.mobile-card-gallery__track');
      if (!track || track.children.length < 2) return;
      sessionStorage.setItem(cueKey(), '1');
      media.style.scrollSnapType = 'none';
      media.scrollTo({ left: Math.round(media.clientWidth * .2), behavior: 'smooth' });
      setTimeout(() => media.scrollTo({ left: 0, behavior: 'smooth' }), 500);
      setTimeout(() => { media.style.scrollSnapType = ''; }, 900);
    };
    setTimeout(play, 850);
  }

  function observe(root=document) {
    if (!mobileQuery.matches) return;
    root.querySelectorAll?.('[data-mobile-card-gallery]').forEach(media => observer.observe(media));
  }
  function start() {
    window.addEventListener('scroll', () => { lastScrollAt = Date.now(); }, { passive: true });
    observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { initialise(entry.target); observer.unobserve(entry.target); } }), {rootMargin:'300px 0px'});
    observe();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
